<template>
  <div class="card">
    <img class="logo" src="/images/terrassa-logo.png" alt="Logo Terrassa" />
    <h2>{{ nombreDifunto }}</h2>
    <!--button class="save-button" @click="updateDiapositivas" :disabled="isButtonDesactivat"-->
    <!--span v-if="isLoading" class="spinner"></span-->
    <!--span>{{ isLoading ? 'Aplicant canvis…' : 'Acceptar' }}</span-->
    <!--/button -->
    <div class="info">
      Per moderar, podeu editar directament els missatges i signatures fent clic
      sobre ells. Les diapositives amb bord verd ja són visibles, mentre que les
      de bord vermell estan ocultes. Utilitzeu la casella "Acceptar" per canviar
      l'estat.
    </div>

    <div class="visible-diapos">
      <span
        >Diapositives acceptades: {{ visibleDiapos?.length }} de
        {{ diapos?.length }}</span
      >
    </div>

    <ul class="lista-diapositivas">
      <li class="lista-diapositivas__headers">
        <div class="diapositiva__media">Imatge/Video</div>
        <div class="form-input diapo-txt-header">Missatge</div>
        <div class="form-input diapo-txt-header">Signatura</div>
        <div class="diapositiva__censor-group">Acceptar</div>
      </li>
      <li
        v-for="(diapo, index) of diapos"
        class="diapositiva"
        :class="[diapo.IsVisible ? 'visible' : 'hidden']"
      >
        <div class="diapositiva__media">
          <span
            v-if="diapo.ContentType === 'video'"
            class="diapositiva__type-badge"
            >VIDEO</span
          >
          <video
            v-if="diapo.ContentType === 'video' && diapo.PathVideo"
            class="diapositiva__img"
            controls
          >
            <source :src="diapo.PathVideo" />
          </video>
          <img v-else class="diapositiva__img" :src="diapo.PathFoto" />
        </div>
        <textarea
          class="form-input"
          v-model="diapo.Missatge"
          @keyup="adjustHeightTxtarea(index)"
          @blur="updateDiapositivas"
          @keyup.enter="updateDiapositivas"
          ref="ref-diapos-txtarea"
          placeholder="Missatge buit"
        />
        <input
          type="text"
          class="form-input"
          v-model="diapo.Signatura"
          placeholder="Signatura buida"
          @blur="updateDiapositivas"
          @keyup.enter="updateDiapositivas"
        />
        <div class="diapositiva__censor-group">
          <span class="diapositiva__censor-label">Acceptar</span>
          <input
            type="checkbox"
            class="diapositiva__censor-input"
            v-model="diapo.IsVisible"
            @change="updateDiapositivas"
          />
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  useTemplateRef,
  watch,
} from "vue";
import axios from "axios";
import { isEqual, cloneDeep } from "lodash";

import { Vetlla, Diapositiva } from "../types/vetlla.ts";
import CustomSwal from "../custom-swal.ts";

export default defineComponent({
  props: {
    idVetlla: {
      required: true,
      type: Number,
    },
  },
  setup(props) {
    const refDiapos = useTemplateRef<HTMLElement[]>("ref-diapos-txtarea");
    const isButtonDesactivat = ref(false);
    const isLoading = ref(false);

    const nombreDifunto = ref<null | string>(null);
    const diapos = ref<null | Diapositiva[]>(null);
    const visibleDiapos = computed(() =>
      diapos.value?.filter((d) => d.IsVisible),
    );
    let originalDiapos: Diapositiva[] = [];

    const adjustHeightTxtarea = (index: number) => {
      refDiapos.value![index].style.height = "1px";
      refDiapos.value![index].style.height =
        25 + refDiapos.value![index].scrollHeight + "px";
    };

    const readDiapos = () => {
      axios.get(`/api/vetlla/read?id=${props.idVetlla}`).then((response) => {
        const vetlla = response.data as Vetlla;
        nombreDifunto.value = vetlla.NombreDifunto;
        const ds = cloneDeep((vetlla.Diapositivas ?? []).reverse());
        originalDiapos = cloneDeep(ds);
        diapos.value = cloneDeep(ds);
      });
    };

    onMounted(() => {
      readDiapos();
    });

    watch(refDiapos, () => {
      for (let i = 0; i < diapos.value!.length; i++) {
        adjustHeightTxtarea(i);
      }
    });

    const updateDiapositivas = () => {
      if (isButtonDesactivat.value) return;

      isButtonDesactivat.value = true;
      isLoading.value = true;

      if (diapos.value) {
        const changes: Diapositiva[] = [];

        for (let i = 0; i < originalDiapos.length; i++) {
          if (!isEqual(originalDiapos[i], diapos.value[i])) {
            changes.push(diapos.value[i]);
          }
        }

        const onComplete = () => {
          isButtonDesactivat.value = false;
          isLoading.value = false;
        };

        if (changes.length === 0) {
          axios
            .get(`/api/vetlla/set-diapo-pendent-false?id=${props.idVetlla}`)
            .then(() => {
              // CustomSwal.fire({
              //   icon: "success",
              //   title: "Canvis guardats",
              // }).then(() => window.location.reload());
              readDiapos();
            })
            .catch((error) => {
              console.error("Error desmarcant pendent:", error);
              CustomSwal.fire({
                icon: "error",
                title: "Error desmarcant com pendent",
              });
            })
            .finally(onComplete);
          return;
        }
        const updateRequests = changes.map((diapo) =>
          axios.post("/api/diapositiva/update", diapo),
        );

        Promise.all(updateRequests)
          .then(() => {
            return axios.get(
              `/api/vetlla/set-diapo-pendent-false?id=${props.idVetlla}`,
            );
          })
          .then(() => {
            readDiapos();
            // CustomSwal.fire({
            //   icon: "success",
            //   title: "Diapositives editades exitosament",
            // }).then(() => {
            //   window.location.reload();
            // });
          })
          .catch((error) => {
            console.error("Error actualitzant diapositives o vetlla:", error);
            CustomSwal.fire({
              icon: "error",
              title: "No s'han pogut guardar les diapositives",
            }).then(() => {
              window.location.reload();
            });
          })
          .finally(onComplete);
      }
    };

    return {
      nombreDifunto,
      diapos,
      visibleDiapos,
      adjustHeightTxtarea,
      updateDiapositivas,
      isButtonDesactivat,
      isLoading,
    };
  },
});
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  gap: 1em;

  padding: 1em;
  border-radius: $rounded-border;

  background-color: $bg-color;

  width: 80%;

  @media (max-width: 768px) {
    width: 100%;
    padding-left: 0.2em;
    padding-right: 0.2em;
  }
}

.logo {
  width: 16em;
}

.lista-diapositivas {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 90%;

  &__headers {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5em;
    font-weight: bold;

    .diapositiva__media {
      width: 40%;
      padding: 0.6em;
    }

    .form-input {
      width: 25%;
      height: auto;
      background: transparent;
      border: none;
      text-align: center;
      padding: 0.6em;
    }

    .diapositiva__censor-group {
      width: 10%;
      height: auto;
      justify-content: center;
      padding: 0.6em;
    }

    @media (max-width: 768px) {
      display: none;
    }
  }
}

.info {
  background-color: #2b2b2b;
  color: white;
  padding: 1em;
  line-height: 1.2em;
  border-radius: $rounded-border;
  width: 90%;
}

.visible {
  opacity: 1;
  border-left: 5px solid green;
  border-right: 5px solid green;
}

.hidden {
  opacity: 0.5;
  border-left: 5px solid red;
  border-right: 5px solid red;
}

.form-input {
  width: 25%;
  border: none;
  background-color: $primary-bg-color;

  @media (max-width: 768px) {
    width: 100%;
  }
}

.diapositiva {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0.6em;
  border-top: $border-top-separator;
  margin-bottom: 0.6em;
  border-radius: $rounded-border;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.2em;
  }

  &__media {
    width: 40%;
    position: relative;
    border-radius: $rounded-border;

    @media (max-width: 768px) {
      width: 100%;
    }
  }

  &__type-badge {
    position: absolute;
    top: 4px;
    left: 4px;
    background: #ff6600;
    color: white;
    font-size: 0.7rem;
    font-weight: bold;
    padding: 2px 6px;
    border-radius: 3px;
    z-index: 1;
  }

  &__img {
    width: 100%;
    border-radius: $rounded-border;

    @media (max-width: 768px) {
      width: 100%;
    }
  }

  &__censor-group {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.2em;
  }

  &__censor-label {
    @media (min-width: 768px) {
      display: none;
    }
  }

  &__censor-input {
    width: 1.4em;
    height: 1.4em;
    accent-color: $primary-color;
  }
}

.save-button {
  @include button($primary-color);

  &__icon {
    color: $bg-color;
  }
}
</style>
